import React, { Component } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { ORDER_STATUS_TYPE } from '../../order-status/OrderStatusType';
import { InventoryLocationSelector } from '../../state/inventory/location/selectors';
import { patchPricingTableItem } from '../../state/pricing/actions';
import {
    PricingTableSelector,
    getPricingTableItem
} from '../../state/pricing/selectors';
import { getQuantityAvailableByInventoryLocationId } from '../../utils/inventory/utils';
import GlobalHelper from "../GlobalHelper.jsx";
import Icon from "../icon/icon.component.jsx";
import ClipSpinner from "../spinner/ClipSpinner";
import {STOCK_DOCUMENTS} from "../../utils/inventory"
import AppContext from "@lightspeed-invoicing/core-client/frontend/app/Context"

const uuidv4 = require('uuid/v4')

class QuoteItemInventoryReserved extends Component {
    constructor(props, context) {
        super(props, context)
        this.state = {
            className: this.props.className || '',
            title: this.props.title || '',
            item: this.props.item || null,
            location: this.props.location || null,
            type: this.props.type || 'quote',
            editable: this.props.editable || false,
            rowId: this.props.item ? this.props.item.id : '',
            uniqueId: uuidv4(),
            modal: '',
            loading: this.props.isWorkflowLoading || false,
            mainObjectId: this.props.mainObjectId || '',
            manualReservedAmount: this.props.item ? parseFloat(this.props.item.attributes.inventoryReservedMeasure) : 0,
            manualReservedAdjustedAmount: this.props.item ? parseFloat(this.props.item.attributes.inventoryReservedAdjustedMeasure) : 0,
            documentStatus: this.props.documentStatus || ""
        }
        this.manualReservedAmountCheck = this.manualReservedAmountCheck.bind(this)
        this.getManualReservedQuantity = this.getManualReservedQuantity.bind(this)
        this.isInventoryActive = this.isInventoryActive.bind(this)
        this.itemReferencesStockDocument = this.itemReferencesStockDocument.bind(this)
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            item: nextProps.item || null,
            location: nextProps.location || null,
            loading: nextProps.isWorkflowLoading,
            mainObjectId: nextProps.mainObjectId || '',
            manualReservedAmount: parseFloat(nextProps.item.attributes.inventoryReservedMeasure) || 0,
            manualReservedAdjustedAmount: parseFloat(nextProps.item.attributes.inventoryReservedAdjustedMeasure) || 0,
        })
    }

    save(event, requested) {
        event?.preventDefault()
        this.setState({loading: true})
        this.props.dispatch(patchPricingTableItem(this.props.itemId, this.props.mainObjectId, this.props.type, {
            inventoryRequestedMeasure: String(requested),
            mainObjectId: this.state.mainObjectId,
        }, false, false))

    }

    isInventoryActive() {
        return AppContext.isInventoryEnabled() && this.props.isTrackingInventory
    }

    getManualReservedQuantity() {
        return this.isInventoryActive()
            ? this.props.documentStatus === ORDER_STATUS_TYPE.StatusOrdered 
                ? this.state.manualReservedAdjustedAmount 
                : this.state.manualReservedAmount
            : this.state.manualReservedAmount
    }

    getInventoryReservedQuantity() {
        return this.isInventoryActive()
            ? this.props.documentStatus === ORDER_STATUS_TYPE.StatusOrdered
                ? parseFloat(this.state.item.attributes.inventoryReservedAdjustedMeasure) 
                : parseFloat(this.state.item.attributes.inventoryReservedMeasure)
            : parseFloat(this.state.item.attributes.inventoryReservedMeasure)
    }

    manualReservedAmountCheck(event, totalMeasure) {
        const { isTrackingInventory } = this.props
        let manualReservedQty = AppContext.isInventoryEnabled() && isTrackingInventory
            ? this.state.manualReservedAdjustedAmount
            : this.state.manualReservedAmount
        
        if (manualReservedQty > totalMeasure) {
            manualReservedQty = totalMeasure
        } else if (manualReservedQty < 0) {
            manualReservedQty = 0
        }
        this.setState({
            manualReservedAmount: manualReservedQty,
            manualReservedAdjustedAmount: manualReservedQty
        })
        return this.save(event, totalMeasure - manualReservedQty)
    }

    itemReferencesStockDocument (){
        const { item } = this.props
        return item?.attributes.references?.length > 0
            && item.attributes.references.find(ref => ref.attributes.referenceKey === STOCK_DOCUMENTS)
    }

    render() {
        if (!this.state.item) {
            return null
        }
        const prod = this.state.item.attributes.itemObject
        if (prod.type !== 'products') {
            return null
        }

        const manualReservedQuantity = this.getManualReservedQuantity()
        const inventoryReservedMeasure = this.getInventoryReservedQuantity()
        const inventoryReceivedMeasure = parseFloat(this.state.item.attributes.inventoryReceivedMeasure)
        const totalMeasure = parseFloat(this.state.item.attributes.totalMeasure)
        const quantityOnHand = Math.max(AppContext.isInventoryEnabled() && this.props.isTrackingInventory
            ? parseFloat(getQuantityAvailableByInventoryLocationId(prod, this.props.documentInventoryLocation?.id))
            : parseFloat(GlobalHelper.getQuantityOnHandFromFullProduct(prod, this.state.location)), 0 )

        let qohForOrder = totalMeasure > quantityOnHand ? quantityOnHand : totalMeasure
        qohForOrder = qohForOrder - inventoryReceivedMeasure
        
        let color = (inventoryReservedMeasure > 0) ? 'warning' : 'secondary'
        if (inventoryReservedMeasure === totalMeasure) {
            if (this.isInventoryActive && this.props.documentStatus == ORDER_STATUS_TYPE.StatusDraft) {
                color = 'info'
            } else {
                color = 'success'
            }
        }

        if (!this.state.editable || this.itemReferencesStockDocument()) {
            return <span
                id={this.state.uniqueId}
                className={'badge badge-pill badge-' + color + ' ' + this.state.className}>
                <Icon value={'boxes'} className={"px-1"} />
                <FormattedMessage
                    id="quote.edit.inventory.reserved_items"
                    defaultMessage="{count}/{total} reserved"
                    values={{
                        count: inventoryReservedMeasure,
                        total: totalMeasure,
                    }}
                />
            </span>
        }
        return <div className={"" + this.state.className} role="group" >
            <OverlayTrigger
                placement={"top"}
                trigger={["hover", "focus"]}
                overlay={
                    <Tooltip
                        tooltipId='tooltip_reserved_inventory'
                    >
                        <FormattedMessage
                            id="quote.edit.inventory.reserved_items"
                            defaultMessage="{count}/{total} reserved"
                            values={{
                                count: inventoryReservedMeasure,
                                total: totalMeasure,
                            }}
                        />
                    </Tooltip>}
            >
                <button
                    id={this.state.uniqueId}
                    style={{ width: "max-content", fontSize: "0.7rem" }}
                    title={this.state.title}
                    type="button"
                    className={'btn btn-sm btn-' + color}
                    data-toggle="dropdown"
                    aria-haspopup="false" aria-expanded="false" disabled={this.state.loading}>
                    {!this.state.loading ? <div className='d-flex align-items-center'>
                        <Icon value={'boxes'} className={"px-1"} />
                        <FormattedMessage
                            id="quote.edit.inventory.reserved_items_short"
                            defaultMessage="{count}/{total}"
                            values={{
                                count: inventoryReservedMeasure,
                                total: totalMeasure,
                            }}
                        />
                        <Icon value={'caret-right'} className={"pl-1"} />
                    </div> : <div className='d-flex align-items-center'>
                        <Icon value={'boxes'} className={"px-1"} />
                        <FormattedMessage
                            id="quote.edit.inventory.reserved_items_short_loading"
                            defaultMessage="{count}/"
                            values={{count: inventoryReservedMeasure}}
                        />
                        <ClipSpinner 
                            height="13px"
                            width="13px"
                            size={10}
                        />
                    </div>}
                </button>

            </OverlayTrigger>

            <div className="dropdown-menu" aria-labelledby="btnGroupDrop1">
                {inventoryReservedMeasure !== totalMeasure &&
                    <a className="dropdown-item" href="#" onClick={(e) => { this.save(e, parseFloat(inventoryReceivedMeasure)) }}>
                        <FormattedMessage
                            id="quote.edit.inventory.reserve_all_items"
                            defaultMessage="Reserve all {count} items"
                            values={{
                                count: this.state.item.attributes.totalMeasure
                            }}
                        />
                        {(totalMeasure - inventoryReservedMeasure) > quantityOnHand && <span className={'ml-1 text-danger'}>
                            <Icon value={'exclamation-circle'} className={'mr-1'} />
                            <FormattedMessage
                                id="quote.edit.inventory.short_items"
                                defaultMessage="You're  short {count} items"
                                values={{
                                    count: (totalMeasure - inventoryReservedMeasure) - quantityOnHand
                                }}
                            />
                        </span>}
                    </a>}

                <span className="dropdown-item d-flex w-100 align-items-center mr-3" >
                    <FormattedMessage
                        id="quote.edit.inventory.reserve_partial"
                        defaultMessage="Reserve"
                    />
                    <input
                        type="number"
                        className='form-control form-control-sm ml-2 col-3 mr-2'
                        value={manualReservedQuantity}
                        max={totalMeasure}
                        min={0}
                        onChange={(e) => {
                            e.preventDefault()
                            this.setState({
                                manualReservedAmount: e.target.value,
                                manualReservedAdjustedAmount: e.target.value
                            })
                        }}>
                    </input>
                    <FormattedMessage
                        id="quote.edit.inventory.reserve_partial_items"
                        defaultMessage="items"
                    />
                    <button type="button" className="btn btn-sm btn-primary ml-2" onClick={(e) => this.manualReservedAmountCheck(e, totalMeasure)}>
                        <FormattedMessage
                            id="quote.edit.inventory.reserve_button"
                            defaultMessage="Reserve"
                        />
                    </button>
                </span>

                {qohForOrder > 0 &&
                    <a className="dropdown-item" href="#" onClick={(e) => { this.save(e, totalMeasure - qohForOrder) }}>
                        <FormattedMessage
                            id="quote.edit.inventory.reserve_on_hand_items"
                            defaultMessage="Reserve every item on hand ({count})"
                            values={{
                                count: qohForOrder
                            }}
                        />
                    </a>}
                {inventoryReservedMeasure > 0 &&
                    <a className="dropdown-item" href="#" onClick={(e) => { this.save(e, totalMeasure) }}>
                        <FormattedMessage
                            id="quote.edit.inventory.release_all_items"
                            defaultMessage="Release all items"
                        />
                    </a>}
            </div>
        </div>

    }

}


const mapState = (state, props) => {
    const id = props.itemId
    const objectId = props.mainObjectId
    const item = getPricingTableItem(state, id, objectId)
    const documentInventoryLocation = InventoryLocationSelector.get(state)
    const isTrackingInventory = PricingTableSelector.getItemInventoryTracking(state, id)
    const isWorkflowLoading = PricingTableSelector.getIsWorkflowLoading(state)
    return {
        ...props,
        item: item,
        isWorkflowLoading: isWorkflowLoading,
        isTrackingInventory: isTrackingInventory,
        documentInventoryLocation: documentInventoryLocation,
    }
}
const mapDispatch = (dispatch) => {
    return {
        patchPricingTableItem: patchPricingTableItem,
        dispatch: dispatch
    }
}
export default connect(mapState, mapDispatch)(injectIntl(QuoteItemInventoryReserved))





// WEBPACK FOOTER //
// ./src/common/quote/iteminventoryreserved.component.jsx